/**
 * Cloud-security
 * cloud-security RESTful API
 *
 * OpenAPI spec version: v1
 * Contact: office@cyan.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';

import { CloneProfileDTOV1 } from '../model/cloneProfileDTOV1';
import { ProfileDTOV1 } from '../model/profileDTOV1';

import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';

@Injectable()
export class ProfileService {
  protected basePath = 'https://10.105.151.61/cms-cloudsecurity-middleware/api';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   * Clone profile by Id.
   *
   * @param profileId profileId
   * @param request request
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cloneProfileUsingPOST(
    profileId: number,
    request?: CloneProfileDTOV1,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ProfileDTOV1>;
  public cloneProfileUsingPOST(
    profileId: number,
    request?: CloneProfileDTOV1,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ProfileDTOV1>>;
  public cloneProfileUsingPOST(
    profileId: number,
    request?: CloneProfileDTOV1,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ProfileDTOV1>>;
  public cloneProfileUsingPOST(
    profileId: number,
    request?: CloneProfileDTOV1,
    observe: any = 'body',
    reportProgress = false
  ): Observable<any> {
    if (profileId === null || profileId === undefined) {
      throw new Error(
        'Required parameter profileId was null or undefined when calling cloneProfileUsingPOST.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (JWT) required
    if (this.configuration.apiKeys && this.configuration.apiKeys.Authorization) {
      headers = headers.set('Authorization', this.configuration.apiKeys.Authorization);
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<ProfileDTOV1>(
      `${this.basePath}/v1/profiles/${encodeURIComponent(String(profileId))}/clone`,
      request,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
}
